import { ImageTypeHandler } from "@/app/(components)/Basic/ImageTypeHandler";
import { FeedPostDto } from "@/api/posts/types";
import { extractDateAndTime, formatDateWithHours } from "@/shared/dates";
import DefaultProfile from "@/assets/graphics/default-profile.svg";
import { twMerge } from "tailwind-merge";

export interface Props {
  feedPost: FeedPostDto;
  className?: string;
}

const NewsFeedPortal = ({ feedPost, className }: Props) => {
  const { date, time } = extractDateAndTime(
    formatDateWithHours(feedPost.createdAt),
  );

  return (
    <div className={twMerge("flex items-center gap-4 w-full", className)}>
      <div className="relative md:w-10 md:h-10 h-8 w-8 shrink-0">
        {feedPost.portalMetadata?.portal?.imageUrl ? (
          <ImageTypeHandler
            src={feedPost.portalMetadata?.portal?.imageUrl}
            alt={feedPost.portalMetadata?.portal?.name}
            className="rounded-full"
            fill
          />
        ) : (
          <DefaultProfile />
        )}
      </div>
      <div className="flex md:flex-col overflow-hidden gap-1 w-full justify-between">
        {feedPost.portalMetadata?.portal?.name}
        <p className="md:text body-4 text-endemicGray-700 flex-col items-end mr-3 md:text-xs flex md:flex-row ml-auto text-xs md:m-0 md:gap-1 endemic:text-secondary">
          <span className="text-right">{date}</span>
          <span className="text-right">{time}</span>
        </p>
      </div>
    </div>
  );
};

export default NewsFeedPortal;
